import { DEFER_PAYMENT_VALUES } from "components/inputs/DeferPaymentSelectInput";

export const getIsDeferPayment = (deferPayment: string) =>
  deferPayment === DEFER_PAYMENT_VALUES.YES;
